import { render } from "./FinalApro.vue?vue&type=template&id=4f39ca9b&scoped=true"
import script from "./FinalApro.vue?vue&type=script&lang=ts"
export * from "./FinalApro.vue?vue&type=script&lang=ts"

import "./FinalApro.vue?vue&type=style&index=0&id=4f39ca9b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4f39ca9b"

export default script